// src/components/CookieFloatingButton.js
import React from 'react';
import { useCookieConsent } from '../context/CookieConsentContext';
import '../style/CookieFloatingButton.css';

function CookieIcon() {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        d="M12 2C8.5 2 5.6 4.1 4.3 7.2 3.5 7.1 2.8 7.6 2.5 8.3 2.1 9.2 2.4 10.2 3.2 10.7 3.1 11.1 3 11.5 3 12c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8zm-2.5 5.5c-.8 0-1.5-.7-1.5-1.5S8.7 4.5 9.5 4.5s1.5.7 1.5 1.5-.7 1.5-1.5 1.5zm5 2c-.8 0-1.5-.7-1.5-1.5S12.7 6 13.5 6s1.5.7 1.5 1.5-.7 1.5-1.5 1.5zm-1 4.5c-1.4 0-2.5-1.1-2.5-2.5S10.1 9 11.5 9s2.5 1.1 2.5 2.5-1.1 2.5-2.5 2.5z"
        fill="currentColor"
      />
    </svg>
  );
}

const CookieFloatingButton = () => {
  const { openSettings } = useCookieConsent();

  return (
  <button
    type="button"
    onClick={openSettings}
    className="cookie-floating-button"
    aria-label="Open cookie settings"
    title="Cookie settings"
  >
    <CookieIcon />
  </button>
  );
};

export default CookieFloatingButton;
